function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.531 17.2049L22.814 21.4869L21.399 22.9019L17.117 18.6189C15.5237 19.8961 13.542 20.5908 11.5 20.5879C6.532 20.5879 2.5 16.5559 2.5 11.5879C2.5 6.61989 6.532 2.58789 11.5 2.58789C16.468 2.58789 20.5 6.61989 20.5 11.5879C20.5029 13.6299 19.8082 15.6116 18.531 17.2049ZM16.525 16.4629C17.7941 15.1578 18.5029 13.4083 18.5 11.5879C18.5 7.71989 15.367 4.58789 11.5 4.58789C7.632 4.58789 4.5 7.71989 4.5 11.5879C4.5 15.4549 7.632 18.5879 11.5 18.5879C13.3204 18.5908 15.0699 17.882 16.375 16.6129L16.525 16.4629ZM10.5 10.5879V7.58789H12.5V10.5879H15.5V12.5879H12.5V15.5879H10.5V12.5879H7.5V10.5879H10.5Z",
  fill: "white"
});

var SvgLoupe = function SvgLoupe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoupe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loupe.4a75dd7e.svg";
export { ForwardRef as ReactComponent };